import React, { useEffect, useState, useCallback } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import NotaEntradaForm from './NotaEntradaForm';
import NotaEntradaDetail from './NotaEntradaDetail';
import { notasEntradaApi } from '../../api/compras';
import { COLORS } from '../../theme';

export default function NotasEntradaList() {
  const [notas, setNotas] = useState([]);
  const [registroAberto, setRegistroAberto] = useState(undefined);

  const carregar = useCallback(() => { notasEntradaApi.listar().then(setNotas).catch(() => {}); }, []);
  useEffect(() => { carregar(); }, [carregar]);

  if (registroAberto === null) {
    return <NotaEntradaForm onVoltar={() => setRegistroAberto(undefined)} onSalvo={carregar} />;
  }
  if (registroAberto !== undefined) {
    return <NotaEntradaDetail notaEntradaId={registroAberto} onVoltar={() => { setRegistroAberto(undefined); carregar(); }} />;
  }

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}`, display: 'flex', justifyContent: 'flex-end' }}>
          <Btn onClick={() => setRegistroAberto(null)}>+ Nova Nota de Entrada</Btn>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>NF</th>
              <th style={{ padding: 10 }}>Fornecedor</th>
              <th style={{ padding: 10 }}>Ordem de Compra</th>
              <th style={{ padding: 10 }}>Data de Emissão</th>
              <th style={{ padding: 10 }}>Valor Total</th>
            </tr>
          </thead>
          <tbody>
            {notas.map(n => (
              <tr key={n.id} onClick={() => setRegistroAberto(n.id)}
                style={{ borderTop: `1px solid ${COLORS.border}`, cursor: 'pointer' }}>
                <td style={{ padding: 10 }}>{n.numero || '-'}/{n.serie || '-'}</td>
                <td style={{ padding: 10 }}>{n.fornecedor_nome}</td>
                <td style={{ padding: 10 }}>#{n.ordem_compra_numero}</td>
                <td style={{ padding: 10 }}>{n.data_emissao ? new Date(n.data_emissao).toLocaleDateString('pt-BR') : '-'}</td>
                <td style={{ padding: 10 }}>R$ {Number(n.valor_total || 0).toFixed(2)}</td>
              </tr>
            ))}
            {notas.length === 0 && (
              <tr><td colSpan={5} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhuma nota de entrada lançada ainda.</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
